import { useCallback, useRef, useState } from 'react';
import api from '../utils/api';
import { apiErrorMessage } from '../utils/apiError';

// window.open after an await has lost the click's user gesture and is pop-up-blocked; a same-tab
// navigation to the .xlsx downloads it without leaving the page.
const startDownload = (link) => {
  const anchor = document.createElement('a');
  anchor.href = link;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const useExport = (endpoint, fallbackError = 'We could not export this list. Please try again.') => {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);
  const inFlight = useRef(false);

  const runExport = useCallback(
    async (params) => {
      if (inFlight.current) return;
      inFlight.current = true;
      setExporting(true);
      setError(null);
      try {
        const { data } = await api.get(endpoint, { params });
        const link = data?.data?.link;
        if (!link) throw new Error('Export answered without a link');
        startDownload(link);
      } catch (failure) {
        setError(apiErrorMessage(failure, fallbackError));
      } finally {
        inFlight.current = false;
        setExporting(false);
      }
    },
    [endpoint, fallbackError]
  );

  const clearError = useCallback(() => setError(null), []);

  return { exporting, error, clearError, runExport };
};

export default useExport;
